import "./style.scss";
import { FC, useEffect, useRef, useState } from "react";
import { FormSummaryArrowSvg } from "@/src/svg/FormSummaryArrowSvg";
import { ApplyFormSummaryConst } from "@/src/constants/apply-online";
import { FileFieldName, IApplyOnline, IFormApplicationProps } from "@/src/types/IApplyOnline";
import { UseFormSetValue } from "react-hook-form";
import { ApplyOnlineDocSvg } from "@/src/svg/ApplyOnlineDocSvg";
import FormSummaryModal from "../FormSummaryModal/FormSummaryModal";
import { RippleWrapper } from "@/src/components/Ripple/RippleWrapper";

const FormSummary: FC<IFormApplicationProps> = ({
  formData,
  handleSubmit,
  register,
  setValue,
  selectedFilesMap,
  setSelectedFilesMap,
  isSubmitDisabled,
}) => {
  const prevFormData = useRef<IApplyOnline | undefined>(null);
  const [activeBlock, setActiveBlock] = useState<string | null>("fast");
  const [fileModalIsActive, setFileModalIsActive] = useState<boolean>(false);
  useEffect(() => {
    if (!formData || !prevFormData.current) {
      prevFormData.current = formData;
      return;
    }

    let lastChangedField: string | null = null;

    const isFilesArray = (val: any): val is File[] => Array.isArray(val);

    for (const key in formData) {
      const newVal = formData[key as keyof IApplyOnline];
      const oldVal = prevFormData.current[key as keyof IApplyOnline];

      if (isFilesArray(newVal) && isFilesArray(oldVal)) {
        const isSame =
          newVal.length === oldVal.length &&
          newVal.every((file, i) => file.name === oldVal[i].name && file.size === oldVal[i].size);

        if (!isSame) lastChangedField = key;
      } else {
        if (newVal !== oldVal) lastChangedField = key;
      }
    }

    if (lastChangedField) {
      const fast = [
        "fullname",
        "phone",
        "email",
        "filePassport",
        "fileCertificate",
        "fileEducation",
      ];
      const dop = ["birthDate", "nationality", "address", "country"];
      const program = ["speciality", "levelEducation", "formStudy", "comment"];
      if (fast.includes(lastChangedField)) setActiveBlock("fast");
      else if (dop.includes(lastChangedField)) setActiveBlock("dop-info");
      else if (program.includes(lastChangedField)) setActiveBlock("program-details");
    }

    prevFormData.current = formData;
  }, [formData]);

  const toggleBlock = (id: string) => {
    setActiveBlock((prev) => (prev === id ? null : id));
  };

  const handleClickDocument = (action: "open" | "close") => {
    setFileModalIsActive(action === "open");
    const headerWrapper = document.querySelector(".header-wrapper");
    // const applyOnlineTitle = document.querySelector(".apply-online-title");
    const applyOnlineSteps = document.querySelector(".apply-online-steps");
    if (action === "open") {
      (headerWrapper as HTMLElement).style.zIndex = "-1";
      // (applyOnlineTitle as HTMLElement).style.zIndex = "-1";
      (applyOnlineSteps as HTMLElement).style.zIndex = "-1";
    } else {
      (headerWrapper as HTMLElement).style.zIndex = "999";
      // (applyOnlineTitle as HTMLElement).style.zIndex = "10";
      (applyOnlineSteps as HTMLElement).style.zIndex = "10";
    }
  };

  return (
    <div className="form-summary">
      <div className="form-summary-content">
        <h1 className="form-summary-title">Краткое содержание</h1>
        {ApplyFormSummaryConst.map((section) => (
          <div className={`form-summary-prev ${section.id}`} key={section.id}>
            <div className="form-summary-prev-header" onClick={() => toggleBlock(section.id)}>
              <h1 className="form-summary-prev-title">{section.title}</h1>
              <div className={`chevron-icon ${activeBlock === section.id ? "active" : ""}`}>
                <FormSummaryArrowSvg />
              </div>
            </div>

            {activeBlock === section.id && (
              <div className="form-summary-prev-body">
                {section.fields.map((field) => {
                  if (field.className === "comment") return null;
                  return (
                    <div className="form-summary-prev-field" key={field.className}>
                      <p className={`form-summary-prev-field-name ${field.className}`}>
                        {field.name}:
                      </p>
                      <p className={`form-summary-prev-field-value ${field.className}`}>
                        {String(formData?.[field.className as keyof IApplyOnline] ?? "-")}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="form-summary-buttons">
        <RippleWrapper>
          <div
            className="form-summary-buttons-file-button"
            onClick={() => {
              setTimeout(() => handleClickDocument("open"), 200);
            }}
          >
            <span>Прикрепить файлы </span>
            <ApplyOnlineDocSvg />
          </div>
        </RippleWrapper>

        <div className="form-summary-buttons-file-quantity">
          <span>Прикрепленые: </span>
          <span>
            {selectedFilesMap ? Object.values(selectedFilesMap).flat().length : "0"} файл(а)
          </span>
        </div>
        <button
          className={`form-summary-buttons-submit ${isSubmitDisabled ? "disabled" : ""}`}
          disabled={isSubmitDisabled}
          type="button"
          onClick={handleSubmit}
        >
          Отправить
        </button>
      </div>
      <FormSummaryModal
        isActive={fileModalIsActive}
        onClose={() => handleClickDocument("close")}
        register={register}
        setValue={setValue as UseFormSetValue<IApplyOnline>}
        selectedFilesMap={selectedFilesMap as Record<FileFieldName, File[]>}
        setSelectedFilesMap={
          setSelectedFilesMap as React.Dispatch<React.SetStateAction<Record<FileFieldName, File[]>>>
        }
      />
    </div>
  );
};

export default FormSummary;
